import { useQuery } from '@tanstack/react-query'
import { getAuthorizationStatus } from '@/api/processes-api'

export function useAuthorizationStatus(processId: string) {
  const query = useQuery({
    queryKey: ['authorizationStatus', processId],
    queryFn: () => getAuthorizationStatus(processId)
  })

  return {
    authorizationStatus: query.data,
    loadingStatus: query.isLoading,
    statusSuccess: query.isSuccess
  }
}
